<template>
  <div>
    <div class="row">
      <div class="col-md-2 d-flex pl-4 border-right">
        <span
          class="dot text-center d-flex justify-content-center align-items-center mt-1"
        >
          <em class="fas fa-calendar-week color-white font-14" />
        </span>
        <div class="ml-4">
          <div class="color-gray-6 font-14 font-weight-normal">
            Año Académico:
          </div>
          <span class="color-black font-16 font-weight-bold">
            <strong>{{ emptyText(info.academicYear) }}</strong>
          </span>
        </div>
      </div>
      <div class="col-md-2">
        <header-item
          :has-edit="userHasPermissions('scolarship.budget')"
          icon="fas fa-calculator color-secondary-22"
          label-class="font-weight-bold color-black"
          title="Presupuesto"
          :value="emptyValue(info.budget) | price"
          @on-edit="$emit('on-edit', info)"
        />
      </div>
      <div class="col-md-2">
        <header-item
          icon="fas fa-check-circle color-secondary-2"
          label-class="font-weight-normal color-secondary-6"
          text="color: red"
          title="Pagado"
          :value="emptyValue(info.paid) | price"
        />
      </div>
      <div class="col-md-2">
        <header-item
          icon="fas fa-clock color-yellow-star"
          label-class="font-weight-normal color-secondary-6"
          title="Actual"
          :value="emptyValue(info.actual) | price"
        />
      </div>
      <div class="col-md-2">
        <header-item
          icon="fas fa-chart-line color-orange"
          label-class="font-weight-normal color-secondary-6"
          title="Proyectado"
          :value="emptyValue(info.projected) | price"
        />
      </div>
      <div class="col-md-2">
        <header-item
          icon="fas fa-check-circle color-green"
          :label-class="evalAvailableColor(info.available)"
          title="Disponible"
          :value="emptyValue(info.available) | price"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderItem from './ResultHeaderItem';

export default {
  name: 'ResultHeader',
  components: {
    HeaderItem,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    evalAvailableColor() {
      return (price) =>
        price
          ? Math.sign(price) > 0
            ? 'font-weight-bold color-secondary-22'
            : 'font-weight-bold color-secondary-20'
          : 'font-weight-bold color-black';
    },
  },
  methods: {
    emptyValue(value) {
      return value == null || value == '' ? 0.0 : value;
    },
    emptyText(value) {
      return value == null || value == '' ? '--' : value;
    },
  },
};
</script>

<style scoped lang="scss">
.dot {
  background-color: #ff7058;
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}

.orange-icon-badge-align {
  vertical-align: top;
}
</style>
